// extracted by mini-css-extract-plugin
export default {"formLayout":"form-layout_formLayout__cOhAm"};